export const organizationConstants = {
    GET_ORGANIZATION_REQUEST: 'GET_ORGANIZATION_REQUEST',
    GET_ORGANIZATION_SUCCESS: 'GET_ORGANIZATION_SUCCESS',
    GET_ORGANIZATION_FAILURE: 'GET_ORGANIZATION_FAILURE',

    UPDATE_ORGANIZATION_REQUEST: 'UPDATE_ORGANIZATION_REQUEST',
    UPDATE_ORGANIZATION_SUCCESS: 'UPDATE_ORGANIZATION_SUCCESS',
    UPDATE_ORGANIZATION_FAILURE: 'UPDATE_ORGANIZATION_FAILURE',

    UPDATE_BASE_CURRENCY_REQUEST: 'UPDATE_BASE_CURRENCY_REQUEST',
    UPDATE_BASE_CURRENCY_SUCCESS: 'UPDATE_BASE_CURRENCY_SUCCESS',
    UPDATE_BASE_CURRENCY_FAILURE: 'UPDATE_BASE_CURRENCY_FAILURE',
};
